import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import {  MatAutocomplete } from '@angular/material/autocomplete';
import { SystemService } from '../../../../services/system.service';
import { NotificationService } from 'src/app/shared/notification.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';


@Component({
  selector: 'category-detail-popup',
  templateUrl: 'category-detail-popup.html',
  styleUrls: ['category-detail-popup.css']

})
export class CategoryDetailPopup {

  editable = false;
  siteId: string;


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  groupCtrl = new UntypedFormControl('');
  filterString: Observable<any>;
  filterGroups$: Observable<any>;

  groups$ = new Observable();

  userAddedGroups = []
  @ViewChild('groupInput',{static:false}) groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto',{static:false}) matAutocomplete: MatAutocomplete;
  constructor(
    public dialogRef: MatDialogRef<CategoryDetailPopup>,
    private systemService: SystemService,
    private notifierService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.siteId = data.siteId;
    delete data.siteId;
    if (data.subsidyForGuests !== "true") { data.subsidyForGuests = "false"; }


  }


  updateCategory(data) {
    this.systemService.updateSiteCategory(data.sitedbid, { updatedOn: moment().unix(), subsidyActive: data.subsidyActive , subsidy : data.subsidy ? data.subsidy : 0, subsidyForGuests: data.subsidyForGuests === "true" ? "true" : "false"});
    this.dialogRef.close()
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  getStatus(value) {
    return value
  }



}